import { Injectable } from "@angular/core";
import { APIURL } from "app/Shared/Constant/API_Urls";
import { ConstantService } from "app/Shared/Services/constant-service";
import { SharedHttpClientService } from "app/Shared/Services/shared-http-client.service";
import { UrlsService } from "app/Shared/Services/urls.service";
import { UserService } from "app/Shared/Services/user.service";
import { generateCsv, asBlob } from "export-to-csv";
import { saveAs } from 'file-saver';
import { MessageService } from "primeng/api";
import { map } from "rxjs";

@Injectable(
  {providedIn: 'root'}
)
export class CAISAuditTrailService {
  CAISAuditTrailData: any = [];

  constructor(private sharedHttpClientService: SharedHttpClientService,
    private urlsService: UrlsService,
    private userService: UserService,
    private messageService: MessageService,
    public constantService: ConstantService) {
  }

  getData(payload: any) {
    return this.sharedHttpClientService.post(this.urlsService.setAPIURl(APIURL.Audit_CAIS_Record_Details), payload)
      .pipe(map((response: Response) => {
        return response;
      }))
  }

  exportToCSV(cols: any, pagename = this.constantService.getApplicationName(), filterData: any = []) {
    let initialTime = new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit'});
    const filename = 'RSMS_CAIS_Audit_Trail_' + this.userService.getyyyyMMddDateFormate(new Date());
    this.messageService.add({ severity: 'info', summary: 'File', detail: 'File Download Started' });
    if (this.CAISAuditTrailData.length > 0) {
      const options: any = {
        fieldSeparator: ',',
        quoteStrings: '"',
        decimalSeparator: '.',
        showLabels: true,
        showTitle: true,
        title: filename,
        useTextFile: false,
        useBom: true,
        useKeysAsHeaders: true,
        filename: filename
      };
      const csvData = this.constantService.getExportData(this.CAISAuditTrailData, cols);
      const csv = generateCsv(options)(csvData);
      const blob = asBlob(options)(csv);
      saveAs(blob,options.filename);

      this.messageService.add({
        severity: 'success', summary: 'File', detail: 'File Download Successfully' + filename
      });
      this.userService.logUserActivity('Export CSV' + ((typeof pagename!=='undefined' && pagename!=='CAIS Audit Trails') ? ' - CAIS Audit Trails' : ''), pagename, {
        'Text1': 'File Download Successfully | ' + (this.CAISAuditTrailData.length > 0 ? this.CAISAuditTrailData.length : 0) + ' records downloaded with file name: ' + options.filename + ' with start time: ' + initialTime + ' and end time: ' + new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit'}),
        'Text2': 'User Filter Parameters: ' + JSON.stringify(filterData.filter((filterParam: { values: string | any[]; }) => (filterParam.values != '' || filterParam.values.length > 0)))
      });
    } else {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'No data found' });
      this.userService.logUserActivity('Export CSV' + ((typeof pagename!=='undefined' && pagename!=='CAIS Audit Trails') ? ' - CAIS Audit Trails' : ''), pagename, {
        'Text1': 'No data found',
        'Text2': 'User Filter Parameters: ' + JSON.stringify(filterData.filter((filterParam: { values: string | any[]; }) => (filterParam.values != '' || filterParam.values.length > 0)))
      });
    }
  }

}